import { useState } from 'react';

import UxSignalsInvitation from '@helsenorge/core-cms/uxsignals-invitation';
import type { UxSignalsSurveyDto } from '@helsenorge/framework-utils/additional-page-content';
import { setSurveysCookie } from '@helsenorge/framework-utils/additional-page-content/utils';

interface UxSignalsWrapperProps {
  survey: UxSignalsSurveyDto;
}

const UxSignalsWrapper: React.FC<UxSignalsWrapperProps> = props => {
  const [isVisible, setIsVisible] = useState(true);

  const handleClose = (): void => {
    setIsVisible(false);
    setSurveysCookie(props.survey.id);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <UxSignalsInvitation
      component={props.survey.component}
      id={props.survey.surveyId}
      closeButtonText={props.survey.closeButtonText}
      disclaimerText={props.survey.disclaimerText}
      onClose={handleClose}
    />
  );
};

export default UxSignalsWrapper;
